function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M191 0h2951c53 0 100 22 135 56 35 35 56 83 56 135v2028c0 40-12 77-33 107-4 10-10 19-18 27-5 5-11 9-18 13-33 28-76 45-122 45H191c-53 0-100-22-135-56-35-35-56-82-56-135V192C0 139 21 92 56 57S138 1 191 1zm-45 2139l1034-1037L146 259v1880zm1148-944L228 2264h2867L2076 1195l-336 286c-26 23-66 24-94 1l-353-287zm894-95l998 1047V250l-998 850zM240 147l1452 1184L3081 147H240z",
  fillRule: "nonzero"
});

var SvgContactMailing = function SvgContactMailing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3333 2410",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactMailing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_mailing.578c3852.svg";
export { ForwardRef as ReactComponent };